import { CALL_API } from "../middleware";
import { InvestorAllocationBody } from "../types/investorProfile";
import { SET_APPLICATION_ID, SET_INTERFACE_CODE, SET_INVESTOR_CLIENTID, SET_IS_PORTFOLIO_AVAILABLE, SET_IWAPP_RMID, SET_APPLICANT_DETAILS, SET_FAMILY_DETAILS, SET_SHOW_MFC_REPORT, SET_APPLICANT_ID, SET_APPLICATION_TYPE, SET_BSE_CLIENT_ACTIVATION_STATUS, SET_PORTFOLIO, SET_APPLICATION_ID_FOR_NOMINEECHECK } from "../types/onBoarding";

export interface IwappRmId {
    iwappRmId: string;
}

interface InvestorClientId {
    investorClientId: string;
}

interface InvApplicantId {
    applicantId: string | number;
}
interface ApplicationType {
    applicationType: string;
    investorName: string
    status: string
    onboardingType: string | number;
    investorType: string;
}

interface ApplicationId {
    applicationId: string | number;
}

interface ApplicationIdForNomineeCheck{
     applicationIdForNomineeCheck:string | number
}

export const storeIwappId =
    (body: IwappRmId) => {
        return {
            type: SET_IWAPP_RMID,
            iwappRmId: body.iwappRmId,
        };
    };

export const storeInvestorClientId = (body: InvestorClientId) => {
    return {
        type: SET_INVESTOR_CLIENTID,
        investorClientId: body.investorClientId
    };
}

export const storeInvApplicantId = (body: InvApplicantId) => {
    return {
        type: SET_APPLICANT_ID,
        applicantId: body.applicantId
    };
}

export const storeApplicationType = (body: ApplicationType) => {
    return {
        type: SET_APPLICATION_TYPE,
        applicationType: body.applicationType,
        investorName: body.investorName,
        status: body.status,
        onboardingType: body.onboardingType,
        investorType: body.investorType
    };
}

export const storeInterfaceCode = (body: string | null) => {
    return {
        type: SET_INTERFACE_CODE,
        clientInterfaceCode: body
    };
}

export const storePortfolio = (portfolio: string) => {
    return {
        type: SET_PORTFOLIO,
        portfolio,
    };
}

export const storeApplicationId = (body: ApplicationId) => {
    return {
        type: SET_APPLICATION_ID,
        applicationId: body.applicationId,
    };
}

export const storeApplicationIdForNomineeCheck=(body:ApplicationIdForNomineeCheck)=>{
    return {
        type:SET_APPLICATION_ID_FOR_NOMINEECHECK,
        applicationIdForNomineeCheck:body.applicationIdForNomineeCheck

    }
}

export const setApplicantDetails =
    ({
        panNo,
        email,
        mobile,
        countryCode
    }: {
        panNo: string;
        email: string;
        mobile: string;
        countryCode: string;
    }): {
        type: string;
        body: {
            panNo: string;
            email: string;
            mobile: string;
            countryCode: string;
        }
    } => {
        return {
            type: SET_APPLICANT_DETAILS,
            body: {
                panNo,
                email,
                mobile,
                countryCode
            }
        };
    };

export const storeIsPortfolioAvailable = (isPortfolioAvailable: boolean): { type: string; isPortfolioAvailable: boolean } => {
    return {
        type: SET_IS_PORTFOLIO_AVAILABLE,
        isPortfolioAvailable,
    };
}

export const setFamilyDetails =
    ({
        familyId,
        familyName
    }: {
        familyId: string,
        familyName: string
    }): { type: string; body: Record<string, string> } => {
        return {
            type: SET_FAMILY_DETAILS,
            body: {
                familyId,
                familyName
            }
        };
    };

export const storeShowMfcReport = (showMfcReport: boolean): { type: string; showMfcReport: boolean } => {
    return {
        type: SET_SHOW_MFC_REPORT,
        showMfcReport,
    };
}

export const storeBseClientActivationStatus = (bseClientActivationStatus: string): { type: string; bseClientActivationStatus: string } => {
    return {
        type: SET_BSE_CLIENT_ACTIVATION_STATUS,
        bseClientActivationStatus,
    };
}

